import React from "react";

import {
    DocumentsPage,
    DocumentsRelatedPage,
    DocumentsRelatedSearchPage,
    DocumentsSearchPage,
} from "@/components/features";
import { fakeI18n } from "@/i18n";
import { AppRoute, RouteItem } from "@/shared/domain";

export const linkedDocumentsRoutes = (): RouteItem[] => {
    return [
        {
            path: AppRoute.RelatedDocuments,
            element: <DocumentsRelatedPage />,
            breadcrumb: fakeI18n.t("Common.Documents"),
        },
        {
            path: AppRoute.RelatedDocumentsSearch,
            element: <DocumentsRelatedSearchPage />,
            breadcrumb: fakeI18n.t("Common.Search"),
        },
        {
            path: AppRoute.FeatureDocuments,
            element: <DocumentsPage />,
            breadcrumb: fakeI18n.t("Common.Documents"),
        },
        {
            path: AppRoute.FeatureDocumentsSearch,
            element: <DocumentsSearchPage />,
            breadcrumb: fakeI18n.t("Common.Search"),
        },
    ];
};
